'use strict';

var pill = {};

exports.__exports = pill;
//# sourceMappingURL=pill.cjs.map
